export default __webpack_public_path__ + "static/dynamicmeta-412dfed19d09b64a84f9782d428b07a0.jpg";